/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * This enum defines the scheduling mode of the exam flow.
 */ 
export enum ExamFlowScheduleMode {
    /**
     * The default scheduling mode. The exam runs will be scheduled automatically.
     */ 
    AutoSchedule = 1,
    /**
     * All exam runs will be scheduled manually by the user.
     */ 
    ManualSchedule = 2,
    /**
     * The first run will be scheduled manually by the user, and all subsequent runs will be scheduled automatically.
     */ 
    FirstRunSchedule = 3,
}
